const socialAuthTypes = [
  'facebook',
  'google',
  'apple',
  'twitter',
  'discord',
  'github',
  'twitch',
  'microsoft',
  'linkedin',
] as const;

export type SocialAuthType = (typeof socialAuthTypes)[number];

export const isSocialAuthType = (authType: string): authType is SocialAuthType => {
  return (socialAuthTypes as readonly string[]).includes(authType);
};
